import React from 'react';
import PropTypes from 'prop-types'
import Select from 'react-select'
import { useFormContext, useController } from "react-hook-form";
import * as R from 'ramda';

const FormSelect = React.forwardRef((
  { name,
    options,
    handleChange,
    getOptionLabel,
    getOptionValue,
    isMulti = false,
    isClearable = true,
    getOptionEqual = (option) => option,
  }, ref) => {
  const { control } = useFormContext()
  const {
    field: { value, onChange, ...inputProps },
  } = useController({ name, control })
  
  const onChangeExtend = onChange => option => {
    if(option) {
      const value = getOptionValue(option)
      onChange(value)
      handleChange(name, value);
    } else {
      onChange('')
      handleChange(name, isMulti ? [] : '');
    }
  }

  const getValue = (checkValue) => {
    if(R.is(Array, checkValue)) {
      return options.filter(option => checkValue.some(v => getOptionEqual(v) === getOptionEqual(option)))
    }
    const checkEquelValue = R.is(Object, checkValue) ? getOptionEqual(checkValue) : checkValue
    return options.find(option => getOptionEqual(option) === checkEquelValue)
  }

  return (
    <Select
      ref={ref}
      isMulti={isMulti}
      isClearable={true}
      value={getValue(value)}
      options={options}
      styles={{
        control: (provided) => ({
          ...provided,
          borderRadius: '0.65rem',
          borderColor: '#e4e6ef',
          fontWeight: 500,
          fontSize: '1.1rem',
        })
      }}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      onChange={onChangeExtend(onChange)}
      {...inputProps}
    />
  )
})

FormSelect.defaultProps = {
  handleChange: () => {},
}

FormSelect.propTypes = {
  onChange: PropTypes.func,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
}

FormSelect.displayName = 'FormSelect';

export default FormSelect;
